if (document.documentElement.lang.split('-')[0] === 'hu') {
/* Gift choice only; the discount is applied and verified by Shopify. */
(function () {
  'use strict';
  function eligibleTotal(cart, eligibleProducts) {
    return (cart.items || []).reduce((sum, item) => sum + (
      (!eligibleProducts || eligibleProducts.has(item.product_id)) && !(item.line_level_discount_allocations || []).length && !item.properties?._pb_cro_gift && !item.selling_plan_allocation
        ? Number(item.original_line_price || 0) : 0
    ), 0);
  }
  function confirmedGift(item, title) {
    return item.quantity === 1 && item.final_line_price === 0 && (item.line_level_discount_allocations || []).some(a => a.discount_application?.title === title && a.amount >= item.original_price);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { eligibleTotal, confirmedGift };
  if (typeof customElements === 'undefined' || customElements.get('pb-cro-gift')) return;
  class GiftChoice extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('[data-gift-select]');
      const button = this.querySelector('[data-gift-add]');
      if (!select || !button) return;
      select.addEventListener('change', () => { button.disabled = !select.value || !!this.busy; });
      button.addEventListener('click', () => this.add(select.value));
    }
    status(text) {
      const current = document.querySelector(`pb-cro-gift[data-tier="${this.dataset.tier}"]`) || this;
      const target = current.querySelector('[data-gift-status]');
      if (target) target.textContent = text;
    }
    async add(id) {
      if (!id || this.busy || !window.PBCroCart) return;
      this.busy = true;
      this.querySelector('[data-gift-add]').disabled = true;
      const products = new Set(JSON.parse(this.querySelector('[data-gift-products]').textContent));
      const eligibleProducts = new Set(JSON.parse(this.querySelector('[data-gift-eligible-products]').textContent));
      const tier = this.dataset.tier, title = this.dataset.discountTitle;
      const root = window.Shopify?.routes?.root || '/';
      const own = item => String(item.variant_id) === id && item.properties?._pb_cro_gift === tier;
      const result = await window.PBCroCart.add(new Map([[id, 1]]), 'cart', {
        properties: { _pb_cro_gift: tier },
        beforeAdd: cart => cart.currency === 'RON' && eligibleTotal(cart, eligibleProducts) >= Number(this.dataset.threshold) && !cart.items.some(item => products.has(item.product_id) || item.properties?._pb_cro_gift === tier),
        finalize: async (before, after, readCart) => {
          const gift = after.items.find(own);
          if (!gift || confirmedGift(gift, title)) return { cart: after, rejected: false };
          // Only remove the newly added, uniquely marked line. Never touch a
          // customer's existing paid item or an item added by another app.
          if (before.items.some(own)) throw new Error('Gift was already present');
          const response = await fetch(`${root}cart/change.js`, {
            method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: gift.key, quantity: 0 })
          });
          if (!response.ok) throw new Error('Cannot remove unconfirmed gift');
          const cart = await readCart();
          if (cart.items.some(own)) throw new Error('Unconfirmed gift remains');
          return { cart, rejected: true };
        }
      });
      if (result.complete) {
        this.status('Az ajándék a kosárba került, és az ingyenességet megerősítettük.');
        window.PBCroAnalytics?.emit('gift_add', { threshold: Number(tier) });
      }
      else if (result.rejected) this.status('A kedvezmény nem érvényesült. A kiválasztott terméket automatikusan eltávolítottuk; nem maradt fizetős ajándék a kosárban.');
      else if (result.blocked) this.status('A kosár megváltozott vagy már tartalmaz ilyen terméket. Ellenőrizd a termékeket és frissítsd a kosarat.');
      else this.status('Az ajándékot nem sikerült megerősíteni. Folytatás előtt ellenőrizd a kosárban szereplő árakat.');
      // A refreshed drawer creates a fresh component. Do not retry uncertain writes.
      this.busy = !!result.uncertain;
      if (this.isConnected && !this.busy) this.querySelector('[data-gift-add]').disabled = false;
    }
  }
  customElements.define('pb-cro-gift', GiftChoice);
})();

} else {
/* Gift choice only; the discount is applied and verified by Shopify. */
(function () {
  'use strict';
  function eligibleTotal(cart, eligibleProducts) {
    return (cart.items || []).reduce((sum, item) => sum + (
      (!eligibleProducts || eligibleProducts.has(item.product_id)) && !(item.line_level_discount_allocations || []).length && !item.properties?._pb_cro_gift && !item.selling_plan_allocation
        ? Number(item.original_line_price || 0) : 0
    ), 0);
  }
  function confirmedGift(item, title) {
    return item.quantity === 1 && item.final_line_price === 0 && (item.line_level_discount_allocations || []).some(a => a.discount_application?.title === title && a.amount >= item.original_price);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { eligibleTotal, confirmedGift };
  if (typeof customElements === 'undefined' || customElements.get('pb-cro-gift')) return;
  class GiftChoice extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('[data-gift-select]');
      const button = this.querySelector('[data-gift-add]');
      if (!select || !button) return;
      select.addEventListener('change', () => { button.disabled = !select.value || !!this.busy; });
      button.addEventListener('click', () => this.add(select.value));
    }
    status(text) {
      const current = document.querySelector(`pb-cro-gift[data-tier="${this.dataset.tier}"]`) || this;
      const target = current.querySelector('[data-gift-status]');
      if (target) target.textContent = text;
    }
    async add(id) {
      if (!id || this.busy || !window.PBCroCart) return;
      this.busy = true;
      this.querySelector('[data-gift-add]').disabled = true;
      const products = new Set(JSON.parse(this.querySelector('[data-gift-products]').textContent));
      const eligibleProducts = new Set(JSON.parse(this.querySelector('[data-gift-eligible-products]').textContent));
      const tier = this.dataset.tier, title = this.dataset.discountTitle;
      const root = window.Shopify?.routes?.root || '/';
      const own = item => String(item.variant_id) === id && item.properties?._pb_cro_gift === tier;
      const result = await window.PBCroCart.add(new Map([[id, 1]]), 'cart', {
        properties: { _pb_cro_gift: tier },
        beforeAdd: cart => cart.currency === 'RON' && eligibleTotal(cart, eligibleProducts) >= Number(this.dataset.threshold) && !cart.items.some(item => products.has(item.product_id) || item.properties?._pb_cro_gift === tier),
        finalize: async (before, after, readCart) => {
          const gift = after.items.find(own);
          if (!gift || confirmedGift(gift, title)) return { cart: after, rejected: false };
          // Only remove the newly added, uniquely marked line. Never touch a
          // customer's existing paid item or an item added by another app.
          if (before.items.some(own)) throw new Error('Gift was already present');
          const response = await fetch(`${root}cart/change.js`, {
            method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: gift.key, quantity: 0 })
          });
          if (!response.ok) throw new Error('Cannot remove unconfirmed gift');
          const cart = await readCart();
          if (cart.items.some(own)) throw new Error('Unconfirmed gift remains');
          return { cart, rejected: true };
        }
      });
      if (result.complete) {
        this.status('Cadoul a fost adăugat, iar gratuitatea a fost confirmată în coș.');
        window.PBCroAnalytics?.emit('gift_add', { threshold: Number(tier) });
      }
      else if (result.rejected) this.status('Reducerea nu s-a aplicat. Produsul ales a fost eliminat automat; nu a rămas un cadou cu plată.');
      else if (result.blocked) this.status('Coșul s-a schimbat sau conține deja un produs din această selecție. Verifică produsele și actualizează coșul.');
      else this.status('Nu am putut confirma cadoul. Verifică prețul produselor din coș înainte să continui.');
      // A refreshed drawer creates a fresh component. Do not retry uncertain writes.
      this.busy = !!result.uncertain;
      if (this.isConnected && !this.busy) this.querySelector('[data-gift-add]').disabled = false;
    }
  }
  customElements.define('pb-cro-gift', GiftChoice);
})();

}
